import type { FieldValues } from "react-hook-form";
import { FormLineItem } from "../FormLineItem";
import { FormYesNo, type FormYesNoProps } from "../fields/FormYesNo";
import type { FormLineItemProps } from "../types";

export type FormYesNoLineItemProps<TFieldValues extends FieldValues> =
	FormLineItemProps<TFieldValues> & Omit<FormYesNoProps<TFieldValues>, "control">;

export const FormYesNoLineItem = <TFieldValues extends FieldValues>({
	formMethods,
	name,
	defaultValue,
	disabled,
	label,
	id,
	tooltip,
	deselectable,
	errorMessage,
	className,
	labelClassName,
	partialRequiresSubmit,
}: FormYesNoLineItemProps<TFieldValues>) => {
	const { control } = formMethods;
	return (
		<FormLineItem
			formMethods={formMethods}
			id={id}
			name={name}
			label={label}
			tooltip={tooltip}
			className={className}
			labelClassName={labelClassName}
			partialRequiresSubmit={partialRequiresSubmit}
		>
			<FormYesNo
				name={name}
				control={control}
				defaultValue={defaultValue}
				disabled={disabled}
				errorMessage={errorMessage}
				deselectable={deselectable}
				compact
			/>
		</FormLineItem>
	);
};
